import { booleanAttribute, Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-chip',
  imports: [MatIcon],
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss',
  host: {
    '[class.removable]': 'removable()',
  },
})
export class ChipComponent {
  removable = input(false, { transform: booleanAttribute });

  removeLabel = input('Remove');

  removed = output<void>();
}
